<template>
  <ClientOnly>
    <div :class="widgetData.container" class="relative">

      <h2>{{ widgetData.title }}<span class="size-1 text-danger">({{ favorites.length }})</span></h2>

      <div v-if="accommodations === false" class="my-4">
        {{ $t('loading') }}
      </div>
      <div class="row favorite_list" v-else-if="accommodations !== false && favorites.length > 0">
        <div class="col-12 col-lg-4 col-xl-8 col-xxl-6" v-for="accommodation in accommodations">
          <ListItem :accommodation="accommodation" :activeLocale="activeLocale" :activeCountry="activeCountry"
                    :widgetName="widgetData.title" :GATrackEvent="GATrackEvent" :currency="activeLocaleCurrency"/>
        </div>
      </div>
      <div class="row mt-4" v-else-if="accommodations !== false && currentUser && currentUser.id > 0">
        <div class="col-12 col-md-6 col-lg-4">
          <div class="alert alert-info">
            {{ $t('no-item-in-favorites') }}
          </div>
        </div>
      </div>
      <div class="row mt-4" v-else-if="accommodations !== false">
        <div class="col-12 col-md-6 col-lg-4">
          <div class="alert alert-info">
            {{ $t('you-must-be-logged-in-to-show-favorites') }}
            <br>
            <button class="btn btn-first mt-2" @click="showLogin">{{ $t('log-in') }}</button>
          </div>
        </div>
      </div>
    </div>
    <template slot="fallback">
      {{ $t('loading') }}
    </template>
  </ClientOnly>

</template>

<script setup lang="ts">
import {onMounted, PropType, ref, watch} from "vue";
import {PageDataHolderFetchedWidget} from "../../../../lib/interfaces/model/PageDataHolderFetchedWidget";
import {useWidget} from "../../../../composables/widget/accommodation_list";
import ListItem from "./acc_list_main/acc_list_main_accommodation_item";
import Accommodation from "../../../../lib/models/Accommodation";
import {useStateFunctionFavorites} from "../../../../composables/state/favorites";
import {getCurrentUser} from "../../../../composables/auth/useAuthUser";
import {useNuxtApp, useState} from "#app";
import {GATracker} from "../../../../composables/ga_tracker";


const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});
const {widgetData, content, activeLocale, activeLocaleCurrency, activeCountry} = useWidget(props.widget);
const {$tyrionApi} = useNuxtApp();

const accommodations = ref<Array<Accommodation> | false>(false);
const limit = ref(15);
const skip = ref(0);

const currentUser = getCurrentUser();
const {favorites, favoriteCount} = useStateFunctionFavorites();
const {GATrackEvent} = GATracker();

watch(favoriteCount, () => {
  skip.value = 0;
  loadItems();
});

onMounted(() => {
  loadItems();
})

const loadItems = async () => {
  if (favorites.value.length > 0) {
    accommodations.value = false;
    $tyrionApi.postTyrionUrl("/api3/client/favorites/products", {
      body: {
        currency: activeLocaleCurrency.code,
        limit: limit.value,
        skip: skip.value
      },
      userTokenRequired: true
    }).then((res) => {
      if (res.status === "success") {
        accommodations.value = res.data.map(i => (new Accommodation()).fromObject(i));
        skip.value += res.data.length;
      }
    }).catch(e => {
      accommodations.value = [];
    })
  } else {
    accommodations.value = [];
  }
};


const showLogin = () => {
  useState('login-modal').value = true;
}
</script>
